import { h, Host, } from "@stencil/core";
import { findVariants, hasTownVillageCityVariant, } from "../../util/WorkElections";
import ZipGeocode from "./zipGeocoding";
/**
 * An input and (optional) select element for a US postal address and state which will look up address values based on
 * the user's input to allow the user to select from.
 */
export class AddressInput {
  constructor() {
    this.m_state = "COMPLETED";
    this.fairfaxCityZIPCodes = [
      "22030",
      "22031",
      "22032",
      "22034",
      "22038",
    ];
    this.cityValue = undefined;
    this.cityTownVillageValue = undefined;
    this.countyValue = undefined;
    this.stateValue = undefined;
    this.zipValue = undefined;
    this.cityOptions = undefined;
    this.cityTownVillageOptions = undefined;
    this.countyOptions = undefined;
    this.stateOptions = undefined;
    this.zipValue = "";
    this.cityValue = "";
    this.cityTownVillageValue = "";
    this.countyValue = "";
    this.stateValue = "";
    this.cityOptions = new Set();
    this.cityTownVillageOptions = new Set();
    this.countyOptions = new Set();
    this.stateOptions = new Map();
  }
  state() {
    return Promise.resolve(this.m_state);
  }
  render() {
    const zipValidationRegex = /^\d{5}$/;
    const onZipInputChange = (event) => {
      this.zipValue = event.target.value;
      if (zipValidationRegex.test(this.zipValue)) {
        this.m_state = "STARTED";
        this.onLookup.emit(this.m_state);
        let isInFairfax = false;
        if (this.fairfaxCityZIPCodes.includes(this.zipValue)) {
          isInFairfax = true;
        }
        ZipGeocode(this.zipValue).then((result) => {
          if ("error" in result) {
            console.log(result.error);
          }
          else {
            this.cityOptions = result.cities;
            this.cityValue = this.cityOptions.values().next().value;
            this.countyOptions = result.counties;
            this.countyValue = this.countyOptions.values().next().value;
            this.stateOptions = result.states;
            this.stateValue = this.stateOptions.keys().next().value;
            if (hasTownVillageCityVariant(this.stateValue, this.countyValue, this.cityValue)) {
              this.cityTownVillageOptions = new Set(findVariants(this.stateValue, this.countyValue, this.cityValue));
              this.cityTownVillageValue = this.cityTownVillageOptions
                .keys()
                .next().value;
            }
            else {
              this.cityTownVillageOptions = new Set();
              this.cityTownVillageValue = "";
            }
            if (isInFairfax) {
              this.countyValue = "Fairfax";
            }
          }
          this.m_state = "COMPLETED";
          this.onLookup.emit(this.m_state);
        });
      }
    };
    return (h(Host, null, h("label", null, "ZIP code ", h("span", { class: "required" }, "*"), h("input", { name: "zip", required: true, value: this.zipValue, pattern: "\\d{5}", maxLength: 5, title: "Please enter a valid ZIP code", onInput: onZipInputChange })), h("input-possibly-hidden-select", { fieldLabel: "City", name: "city", selected: this.cityValue, options: this.cityOptions }), h("input-possibly-hidden-select", { fieldLabel: "City/Town/Village", name: "city_town_village", selected: this.cityTownVillageValue, options: this.cityTownVillageOptions }), h("input-possibly-hidden-select", { fieldLabel: "County", name: "user_county", selected: this.countyValue, options: this.countyOptions }), h("input-possibly-hidden-select", { fieldLabel: "State", name: "state", selected: this.stateValue, options: this.stateOptions })));
  }
  static get is() { return "input-address"; }
  static get states() {
    return {
      "cityValue": {},
      "cityTownVillageValue": {},
      "countyValue": {},
      "stateValue": {},
      "zipValue": {},
      "cityOptions": {},
      "cityTownVillageOptions": {},
      "countyOptions": {},
      "stateOptions": {}
    };
  }
  static get events() {
    return [{
        "method": "onLookup",
        "name": "lookup",
        "bubbles": true,
        "cancelable": false,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "\"STARTED\" | \"COMPLETED\"",
          "resolved": "\"COMPLETED\" | \"STARTED\"",
          "references": {}
        }
      }];
  }
  static get methods() {
    return {
      "state": {
        "complexType": {
          "signature": "() => Promise<\"STARTED\" | \"COMPLETED\">",
          "parameters": [],
          "references": {
            "Promise": {
              "location": "global"
            }
          },
          "return": "Promise<\"STARTED\" | \"COMPLETED\">"
        },
        "docs": {
          "text": "",
          "tags": []
        }
      }
    };
  }
}
//# sourceMappingURL=input-address.js.map
